module.exports = __webpack_public_path__ + "img/sj_tiekuangshi.c0c2ae7a.jpg";